import { render, staticRenderFns } from "./knowledge-points-r.vue?vue&type=template&id=07e55cc6"
import script from "./knowledge-points-r.vue?vue&type=script&lang=js"
export * from "./knowledge-points-r.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports